module.exports = __webpack_public_path__ + "media/1x1/to-238ef1cd.svg";